<template>
  <div>
    <div v-if="type === 'nominale'">
      <form-field-km v-model="kmValue" :km="km" :km_placeholder="km_placeholder"></form-field-km>
      <form-field-date :anni="anni" :mesi="mesi" :type="type" @validation="updateDateValidation" />
      <form-field-average
        v-if="liveMarketExists"
        :kmMensili="kmMensili"
        :cap="cap"
      ></form-field-average>
    </div>

    <div v-else-if="type === 'live-market'">
      <form-field-km v-model="kmValue" :km="km" :km_placeholder="km_placeholder"></form-field-km>
      <form-field-date :anni="anni" :mesi="mesi" :type="type" @validation="updateDateValidation" />
      <form-field-average
        :kmMensili="kmMensili"
        :cap="cap"
      ></form-field-average>
    </div>

    <div v-else-if="type === 'storica'">
      <form-field-date :anni="anni" :mesi="mesi" :type="type" @validation="updateDateValidation" />
      <form-field-add-info :required="false" :min-chars="10" @validation="onAddInfoValidation" />
    </div>
  </div>
</template>

<script>
import FormFieldKm from './FormFieldKm.vue';
import FormFieldDate from './FormFieldDate.vue';
import FormFieldAddInfo from './FormFieldAddInfo.vue';
import FormFieldAverage from './FormFieldAverage.vue';
import BikeNotes from './BikeNotes.vue';

export default {
  name: 'FormFields',
  components: { FormFieldKm, FormFieldDate, FormFieldAddInfo, FormFieldAverage, BikeNotes },
  props: {
    type: { type: String, required: true },
    km: { type: Number, required: false },
    km_placeholder: { type: [Number, String], required: false },
    kmMensili: { type: Number, required: false },
    cap: { type: String, required: false },
    liveMarketExists: { type: Boolean, default: false },
    notes: { type: Object, required: false },
    anni: { type: [String, Object], required: false },
    mesi: { type: Object, required: false },
  },
  data() {
    return {
      kmValue: this.km,
      isDateValidInternal: false,
      isAddInfoValidInternal: this.type === 'storica' ? false : true,
    };
  },
  computed: {
    isFormValid() {
      return this.type === 'storica'
        ? this.isDateValidInternal && this.isAddInfoValidInternal
        : this.isDateValidInternal;
    },
  },
  watch: {
    km(newVal) {
      this.kmValue = newVal;
    },
    kmValue(newVal) {
      this.$emit('update:km', newVal);
    },
    type(newType) {
      this.isAddInfoValidInternal = newType === 'storica' ? false : true;
      this.$emit('date-validation', this.isFormValid);
    },
  },
  methods: {
    updateDateValidation(isValid) {
      this.isDateValidInternal = isValid;
      this.$emit('date-validation', this.isFormValid);
    },
    onAddInfoValidation(isValid) {
      this.isAddInfoValidInternal = isValid;
      this.$emit('date-validation', this.isFormValid);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/FormFields.vue